import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import QueryQuotaNoHolder from './QueryQuotaNoHolder';
import { newAlert } from '../../../actions/alert_actions';
import {
  queryQuotasNoHolder,
  closeQueryQuotaNoHolderModal,
  resetQueryData
} from '../../../actions/query_quota_actions';

function mapStateToProps(state) {
  return {
    loading: state.requestState.requestQueryQuotasSend,
    serverErrors: state.requestState.requestErrorsOnQueryQuotas || [],
    quotas: state.queryQuotas.quotas,
    isOpen: state.queryQuotas.isQueryQuotaNoHolderModalOpen,
    hasSearched: state.queryQuotas.hasSearched,
    generalWarrantyCaseThreeCategoriesConfig: state.globalSetting.orgData.general_warranty_case_three_categories_config,
    categories: state.globalSetting.orgData.categories,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    newAlert: bindActionCreators(newAlert, dispatch),
    queryQuotasNoHolder: bindActionCreators(queryQuotasNoHolder, dispatch),
    closeModal: bindActionCreators(closeQueryQuotaNoHolderModal, dispatch),
    resetQueryData: bindActionCreators(resetQueryData, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(QueryQuotaNoHolder);
